import * as React from 'react'
import Link from 'next/link'

import Image from '~/truck/image'
import NewButton from '~/truck/new-button/NewButton'
import theme from '~/truck/theme'
import type { ThemeColor } from '~/types/theme'

export interface EmptyStateProps {
  image: string
  title: string
  subtitle: string
  actionProps?: {
    route: string
    label: string
    onClick?: () => void
    color?: ThemeColor
  }
  /**
   * @deprecated
   */
  style?: React.CSSProperties
}

export default function EmptyState(props: EmptyStateProps) {
  const { image, title, subtitle, actionProps, style } = props

  return (
    <div className="flex flex-grow flex-col items-center justify-center gap-4" style={style}>
      <Image src={image} height={theme.spacing.cozy * 9} width={theme.spacing.cozy * 9} />
      <h5 className="text-center font-semibold">{title}</h5>
      <p className="max-w-[200px] text-center">{subtitle}</p>
      {actionProps ? (
        <NewButton
          asChild
          variant={(actionProps.color as 'primary' | 'secondary' | 'critical' | 'info') ?? 'primary'}
          className="w-fit min-w-[200px] px-6"
        >
          <Link href={actionProps.route} onClick={actionProps.onClick}>
            {actionProps.label}
          </Link>
        </NewButton>
      ) : null}
    </div>
  )
}
